// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"49ebccd7","24":"4c2c4d5d","81":"dbb7a1b7","96":"443ce938","119":"8633bc66","198":"9214fcb2","288":"8282afbb","324":"85075706","404":"c3d63b22","431":"c8d892d2","787":"24cc0628","808":"ec8022a3","815":"f8028e4e","837":"d5cd9493"}[chunkId] + ".chunk.js";
};